import React, { useEffect, useState } from "react";
import { CircularProgress, Button, Paper, List } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ModernTutorCard from "./TutorBox/ModernTutorCard";
import { loadMoreAndFetchTutors } from "../../../store/search";
import { ReactComponent as UnderCurve } from "../../../assets/images/undercurve.tsx";
import config from "config";

const ResultBox = ({ loading: tutorsLoading }) => {
  const dispatch = useDispatch();
  const { resultCount, results, loading, filters } = useSelector(
    (state) => state.search
  );
  const loadMoreResults = results.length < resultCount;
  const resultText =
    resultCount === 0
      ? ""
      : `${config["search-result-title"]} tutor${
          resultCount === 1 ? " found" : "s found"
        }`;
  const selectedLevel = filters.level;
  const selectedExam = filters.exam;

  // Use state to store filtered tutors
  const [filteredTutors, setFilteredTutors] = useState(results);

  useEffect(() => {
    let filtered = results;

    setFilteredTutors(filtered);
  }, [filters, results, selectedLevel, selectedExam]);
  
  // Show the large loader only for the initial load (no results yet)
  const showLoader = tutorsLoading && results.length === 0;
  
  const showNoResults = !tutorsLoading && !loading && resultCount === 0;

  return (
    <Paper
      className="result-box"
      elevation={0}
      sx={{
        maxHeight: {
          md: "75vh",
        },
        overflow: {
          md: "auto",
        },
      }}
    >
      <List>
        {showLoader && (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginTop: "10rem",
            }}
          >
            <CircularProgress size="3rem" />
          </div>
        )}
        
        {showNoResults && (
          <div className="no-tutor">
            <div className="sub-title">No tutors Found</div>
            <UnderCurve />
          </div>
        )}
        
        <div className="name-box">
          {!tutorsLoading && resultCount > 0 && (
            <span style={{ fontSize: "15pt", marginBottom: "10px" }}>
              <span className={`${config["primary-text-colour-class"]}`}>
                {resultCount}
              </span>{" "}
              {resultText}
            </span>
          )}
        </div>
        
        <div className="search-box">
          {!tutorsLoading && filteredTutors.map((tutor, index) => (
            <ModernTutorCard key={tutor?._id || index} tutor={tutor} />
          ))}
        </div>
        
        {loadMoreResults && !tutorsLoading && (
          <div className="pagination-box">
            <Button
              type="button"
              variant="contained"
              size="small"
              style={{
                borderRadius: "4px",
                fontWeight: "bold",
                fontSize: "13pt",
                padding: "0.5rem 2rem",
              }}
              disabled={loading}
              aria-busy={loading}
              onClick={() => dispatch(loadMoreAndFetchTutors())}
              className="clear"
            >
              {loading ? (
                <CircularProgress style={{ color: "white" }} size="2rem" />
              ) : (
                "Load more"
              )}
            </Button>
          </div>
        )}
      </List>
    </Paper>
  );
};

export default ResultBox;
